import React from "react";
import Modal from "../../design-system/components/modals/Modal";
import { PrimaryButton } from "../../design-system/components/buttons";
import { ClockIcon } from "../../design-system/icons";
import { borders, surfaces, textColors, typography } from "../../design-system/tokens";
import { SUBSCRIPTIONS_DISABLED_MESSAGE } from "../../core/utils/subscriptionConfigApi";

const SubscriptionUnavailableModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Subscriptions coming soon"
      size="md"
      closeOnOverlayClick
      closeOnEsc
      showCloseButton
      footer={
        <PrimaryButton type="button" onClick={onClose}>
          Got it
        </PrimaryButton>
      }
    >
      <div className="space-y-5">
        <div className="flex items-center justify-center">
          <div className={`flex items-center justify-center w-14 h-14 rounded-full border ${borders.default} ${surfaces.secondary}`}>
            <ClockIcon size="xl" color="primary" />
          </div>
        </div>

        <div className={`${typography.body} ${textColors.secondary} text-center`}>{SUBSCRIPTIONS_DISABLED_MESSAGE}</div>
        <div className={`${typography.caption} ${textColors.tertiary} text-center`}>No payment was taken.</div>
      </div>
    </Modal>
  );
};

export default SubscriptionUnavailableModal;

